
import { useState } from 'react';

export default function QuickOrder() {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    endereco: '',
    bairro: '',
    quantidade: '1',
    produto: 'gas13kg',
    formaPagamento: 'dinheiro',
    observacoes: ''
  });

  const produtos = {
    gas13kg: { nome: 'Gás de Cozinha 13kg', preco: 110.00 },
    glp20kg: { nome: 'GLP 20kg', preco: 210.50 },
    glp45kg: { nome: 'GLP 45kg', preco: 416.50 },
    vasilhame13kg_vazio: { nome: 'Vasilhame GLP 13kg (vazio)', preco: 230.00 },
    vasilhame13kg_cheio: { nome: 'Vasilhame GLP 13kg (cheio)', preco: 340.00 }
  };

  const formasPagamento = {
    dinheiro: 'Dinheiro',
    pix: 'PIX',
    cartao_credito: 'Cartão - Crédito',
    cartao_debito: 'Cartão - Débito'
  };

  const calcularTotal = () => {
    const produto = produtos[formData.produto as keyof typeof produtos];
    const quantidade = parseInt(formData.quantidade);
    return produto.preco * quantidade;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const produto = produtos[formData.produto as keyof typeof produtos];
    const quantidade = parseInt(formData.quantidade);
    const total = calcularTotal();
    const formaPagamento = formasPagamento[formData.formaPagamento as keyof typeof formasPagamento];
    
    // Criar mensagem formatada para WhatsApp
    const mensagem = `🔥 *NOVO PEDIDO DE GÁS* 🔥

👤 *Cliente:* ${formData.nome}
📱 *Telefone:* ${formData.telefone}
📍 *Endereço:* ${formData.endereco}
🏘️ *Bairro:* ${formData.bairro}
📦 *Produto:* ${produto.nome}
🔢 *Quantidade:* ${quantidade}
💳 *Forma de Pagamento:* ${formaPagamento}
💰 *Valor Total:* R$ ${total.toFixed(2).replace('.', ',')}
${formData.observacoes ? `📝 *Observações:* ${formData.observacoes}` : ''}

⏰ *Pedido feito em:* ${new Date().toLocaleString('pt-BR')}`;

    // Codificar a mensagem para URL
    const mensagemCodificada = encodeURIComponent(mensagem);
    
    // Abrir WhatsApp com a mensagem
    const whatsappUrl = `https://wa.me/5534999645580?text=${mensagemCodificada}`;
    window.open(whatsappUrl, '_blank');
    
    // Limpar formulário após envio
    setFormData({
      nome: '',
      telefone: '',
      endereco: '',
      bairro: '',
      quantidade: '1',
      produto: 'gas13kg',
      formaPagamento: 'dinheiro',
      observacoes: ''
    });
  };

  return (
    <section id="pedido" className="py-20 bg-gradient-to-br from-red-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              <span className="text-red-600">FAÇA SEU PEDIDO</span> AGORA
            </h2>
            <p className="text-2xl text-gray-700 max-w-3xl mx-auto font-medium">
              Preencha os dados abaixo e envie direto para nosso WhatsApp
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            {/* Form - Takes 2 columns */}
            <div className="lg:col-span-2 bg-white rounded-3xl shadow-2xl p-10 border-2 border-red-100">
              <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nome" className="block text-lg font-bold text-gray-800 mb-3">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleInputChange}
                      required
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg"
                      placeholder="Seu nome completo"
                    />
                  </div>

                  <div>
                    <label htmlFor="telefone" className="block text-lg font-bold text-gray-800 mb-3">
                      Telefone/WhatsApp *
                    </label>
                    <input
                      type="tel"
                      id="telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg"
                      placeholder="(11) 99999-9999"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="endereco" className="block text-lg font-bold text-gray-800 mb-3">
                    Endereço Completo *
                  </label>
                  <input
                    type="text"
                    id="endereco"
                    name="endereco"
                    value={formData.endereco}
                    onChange={handleInputChange}
                    required
                    className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg"
                    placeholder="Rua, número, complemento"
                  />
                </div>

                <div>
                  <label htmlFor="bairro" className="block text-lg font-bold text-gray-800 mb-3">
                    Bairro *
                  </label>
                  <input
                    type="text"
                    id="bairro"
                    name="bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                    required
                    className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg"
                    placeholder="Seu bairro"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="produto" className="block text-lg font-bold text-gray-800 mb-3">
                      Produtos
                    </label>
                    <div className="relative">
                      <select
                        id="produto"
                        name="produto"
                        value={formData.produto}
                        onChange={handleInputChange}
                        className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg pr-12 appearance-none cursor-pointer"
                      >
                        <option value="gas13kg">Gás de Cozinha 13kg - R$ 110,00</option>
                        <option value="glp20kg">GLP 20kg - R$ 210,50</option>
                        <option value="glp45kg">GLP 45kg - R$ 416,50</option>
                        <option value="vasilhame13kg_vazio">Vasilhame GLP 13kg (vazio) - R$ 230,00</option>
                        <option value="vasilhame13kg_cheio">Vasilhame GLP 13kg (cheio) - R$ 340,00</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-xl"></i>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="quantidade" className="block text-lg font-bold text-gray-800 mb-3">
                      Quantidade
                    </label>
                    <div className="relative">
                      <select
                        id="quantidade"
                        name="quantidade"
                        value={formData.quantidade}
                        onChange={handleInputChange}
                        className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg pr-12 appearance-none cursor-pointer"
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-xl"></i>
                    </div>
                  </div>
                </div>

                <div>
                  <label htmlFor="formaPagamento" className="block text-lg font-bold text-gray-800 mb-3">
                    Forma de Pagamento
                  </label>
                  <div className="relative">
                    <select
                      id="formaPagamento"
                      name="formaPagamento"
                      value={formData.formaPagamento}
                      onChange={handleInputChange}
                      className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg pr-12 appearance-none cursor-pointer"
                    >
                      <option value="dinheiro">Dinheiro</option>
                      <option value="pix">PIX</option>
                      <option value="cartao_credito">Cartão - Crédito</option>
                      <option value="cartao_debito">Cartão - Débito</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none text-xl"></i>
                  </div>
                </div>

                {/* Total Display */}
                <div className="bg-gradient-to-r from-red-100 to-blue-100 p-6 rounded-2xl border-2 border-red-200">
                  <div className="flex justify-between items-center">
                    <span className="text-xl font-bold text-gray-900">Valor Total:</span>
                    <span className="text-2xl font-bold text-red-600">
                      R$ {calcularTotal().toFixed(2).replace('.', ',')}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mt-2">Frete incluido no valor</p>
                </div>

                <div>
                  <label htmlFor="observacoes" className="block text-lg font-bold text-gray-800 mb-3">
                    Observações
                  </label>
                  <textarea
                    id="observacoes"
                    name="observacoes"
                    value={formData.observacoes}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-6 py-4 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-red-200 focus:border-red-500 text-lg resize-none"
                    placeholder="Informações adicionais (ponto de referência, etc.)"
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-2">{formData.observacoes.length}/500 caracteres</p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-red-600 text-white py-6 px-8 rounded-xl text-2xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap shadow-2xl"
                >
                  <i className="ri-whatsapp-fill mr-3"></i>
                  ENVIAR PEDIDO VIA WHATSAPP
                </button>
              </form>
            </div>

            {/* Quick Contact Options */}
            <div className="space-y-6">
              <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-blue-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Pedido Rápido</h3>
                
                <div className="space-y-6">
                  <a 
                    href="https://wa.me/5534999645580?text=Olá! Gostaria de fazer um pedido de gás de cozinha."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center p-6 bg-green-50 border-2 border-green-200 rounded-2xl hover:bg-green-100 transition-all transform hover:scale-105 cursor-pointer"
                  >
                    <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-whatsapp-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">WhatsApp</h4>
                      <p className="text-gray-600">Peça agora pelo WhatsApp</p>
                    </div>
                  </a>

                  <a 
                    href="tel:+5534999645580"
                    className="flex items-center p-6 bg-blue-50 border-2 border-blue-200 rounded-2xl hover:bg-blue-100 transition-all transform hover:scale-105 cursor-pointer"
                  >
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-phone-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">Telefone</h4>
                      <p className="text-gray-600">(34) 99964-5580</p>
                    </div>
                  </a>
                </div>
              </div>

              <div className="bg-gradient-to-br from-red-100 to-blue-100 border-2 border-red-200 rounded-3xl p-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-information-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-4 text-lg">Informações Importantes</h4>
                    <ul className="text-gray-800 space-y-2 font-medium">
                      <li>• Entrega em até 2 horas</li>
                      <li>• Frete incluso no valor</li>
                      <li>• Pagamento via Cartão, Dinheiro ou PIX</li>
                      <li>• Atendimento das 8h às 18h</li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
